const SUPPORTED_TRANSACTION_ASSETS = ['xdai', 'eure', 'gbpe', 'crc', 'usdc', 'usdc-old', 'gno'];

export const isValidTransactionAsset = (assetId: string): boolean => {
  return SUPPORTED_TRANSACTION_ASSETS.includes(assetId);
};
